import { Badge } from "@chakra-ui/react";
import { ReactNode } from "react";

interface StandardAlertBadgeProps {
  content: ReactNode;
  bgColor?: string;
  textColor?: string;
  top?: string;
  right?: string;
  position?: string;
}

export const StandardAlertBadge = ({
  content,
  bgColor,
  textColor,
  right,
  top,
  position,
}: StandardAlertBadgeProps) => {
  return (
    <Badge
      top={top}
      right={right}
      position={position}
      display="inline-flex"
      alignItems="center"
      justifyContent="center"
      borderRadius="full"
      px={2}
      fontSize="10px"
      lineHeight="1"
      minW={"18px"}
      textAlign="center"
      bgColor={bgColor}
      color={textColor}
    >
      {content ?? null}
    </Badge>
  );
};
